// Utility functions for inventory management

export const getInitialInventoryFormData = () => ({
  name: '',
  serial_number: '',
  description: '',
  quantity: '',
});

export const getInventoryFormDataFromRecord = (item) => ({
  name: item.name || '',
  serial_number: item.serial_number || '',
  description: item.description || '',
  quantity: item.quantity || '',
});

export const formatInventoryDataForSubmission = (formData) => {
  const submissionData = {
    name: formData.name.trim(),
    serial_number: formData.serial_number?.trim() || null,
    description: formData.description?.trim() || '',
    quantity: parseInt(formData.quantity, 10),
  };

  return submissionData;
};

export const getStockStatusColor = (quantity, threshold = 5) => {
  if (quantity <= 0) return 'error';
  if (quantity <= threshold) return 'warning';
  return 'success';
};

export const getStockStatusText = (quantity, threshold = 5) => {
  if (quantity <= 0) return 'Out of Stock';
  if (quantity <= threshold) return 'Low Stock';
  return 'In Stock';
};